import {observer} from "mobx-react-lite"
import React from "react"
import {StockUpdateSettings} from "./StockUpdateSettings"
import {Field, Fields, Select} from "../../lib/wa-2.0"
import controller from "../../store/pageControllers/StockSettingsController"
import {Route, useHistory, useLocation} from "react-router"
import {appPages} from "../../App"
import classNames from "classnames"
import {StockUpdateLauncher} from "./StockUpdateLauncher"
import StocksHistoryComponent from "./StocksHistoryComponent"
import ProductHistoryComponent from "./ProductHistoryComponent"
import "../priceUpdate/priceUpdate.sass"


export const StockUpdatePage = observer(() => {

    const history = useHistory();
    const location = useLocation();
    const Tabs = [
        {
            path: [appPages.stockSync],
            name: 'Настройки'
        },{
            path: [appPages.stockSync + '/launcher/'],
            name: 'Запуск'
        },{
            path: [
                appPages.stockSync + '/history/',
                appPages.stockSync + '/history/product/',
            ],
            name: 'История'
        },
    ]

    return <div>
        <h1>Обновление остатков</h1>


        <ul className={'ozon_price_tabs'}>
            {Tabs.map((el, index) =>
                <li
                    key={index}
                    onClick={() => history.push(el.path[0])}
                    className={classNames({
                        active: el.path.includes(location.pathname)})}
                >{el.name}</li>
            )}
        </ul>

        <React.Fragment>
            <Route exact path={appPages.stockSync + '/'} component={StockUpdateSettings}/>
            <Route exact path={appPages.stockSync + '/launcher/'} component={StockUpdateLauncher}/>
            <Route exact path={appPages.stockSync + '/history/'} component={StocksHistoryComponent}/>
            <Route exact path={appPages.stockSync + '/history/product/:product_id'} component={ProductHistoryComponent}/>

        </React.Fragment>


    </div>
})